<template>
    <DxPopup :visible="visible" @update:visible="onVisibleChange" :show-title="true" width="1000" height="820"
        position="center" :drag-enabled="false" :hide-on-outside-click="false" :show-close-button="false"
        :wrapper-attr="{ class: 'era-etichete-popup' }">
        <template #title>
            <div class="popup-header">
                <div class="popup-header-main">
                    <span class="popup-header-icon dx-icon-tags"></span>
                    <div class="popup-header-texts">
                        <div class="popup-header-title">Etichete stoc</div>
                        <div class="popup-header-subtitle">{{ subtitle }}</div>
                    </div>
                </div>
                <DxButton icon="close" styling-mode="text" class="popup-close-btn" @click="close" />
            </div>
        </template>

        <div class="etichete-popup-content">
            <div class="etichete-toolbar">
                <DxButton v-if="activeLinieId" text="Generează" icon="plus" type="default" styling-mode="outlined"
                    :disabled="loading" @click="onGenereaza(false)" />
                <DxButton v-if="!linieId" text="Generează pentru toate liniile" icon="plus" type="default"
                    styling-mode="outlined" :disabled="loading" @click="onGenereazaToate" />
                <DxButton text="Reîncarcă" icon="refresh" styling-mode="text" :disabled="loading"
                    @click="loadData" />
                <DxButton v-if="activeLinieId && etichete.length > 0" text="Tipărește toate" icon="print" type="success"
                    styling-mode="outlined" :disabled="loading" @click="onTipareteToate" />
            </div>

            <div class="etichete-scan-row">
                <DxTextBox ref="scanTextBoxRef" placeholder="Scanare / introducere cod de bare (Enter)"
                    v-model:value="scanValue" :disabled="loading" @enter-key="onScan" />
            </div>

            <!-- Mod document (fără linie fixată): grid Linii — selecția alimentează grid-ul de Etichete de mai jos,
                 exact ca în legacy (gridView1_FocusedRowChanged → filtrează EticheteStoc pe LinieID) -->
            <DxDataGrid v-if="!linieId" :data-source="liniiDocument" key-expr="Id" height="220" :show-borders="true"
                :show-column-lines="false" :show-row-lines="true" :row-alternation-enabled="true"
                :hover-state-enabled="true" :column-auto-width="true" :column-min-width="70"
                :allow-column-resizing="true" column-resizing-mode="nextColumn"
                :allow-column-reordering="true"
                @selection-changed="onLinieSelectionChanged">
                <DxSelection mode="single" />
                <DxColumn data-field="Produs.Cod" caption="Cod" width="90" />
                <DxColumn data-field="Produs.CodIntern" caption="Cod Intern" width="100" />
                <DxColumn data-field="Produs.Nume" caption="Denumire" />
                <DxColumn data-field="Cantitate" caption="Cantitate" data-type="number" format="#,##0.00"
                    width="100" />
                <DxColumn data-field="CantitateFa" caption="Etichete" data-type="number" width="90" />
                <DxColumn data-field="CantitatePt1Fa" caption="Cant./Etichetă" data-type="number" width="110" />
            </DxDataGrid>

            <div v-if="!linieId" class="scanari-header">
                {{ activeLinieId ? 'Etichete generate — linia selectată' : 'Etichete generate — selectează o linie mai sus' }}
            </div>

            <!-- Grid etichete generate (PRO_EticheteStoc) — mod linie fixată SAU linie selectată în grid-ul de mai sus -->
            <DxDataGrid v-if="activeLinieId" :data-source="etichete" key-expr="Id" height="260" :show-borders="true"
                :show-column-lines="false" :show-row-lines="true" :row-alternation-enabled="true"
                :hover-state-enabled="true" :column-auto-width="true" :column-min-width="70"
                :allow-column-resizing="true" column-resizing-mode="nextColumn"
                :allow-column-reordering="true">
                <DxColumn data-field="ProdusCod" caption="Cod" width="90" />
                <DxColumn data-field="ProdusCodIntern" caption="Cod Intern" width="100" />
                <DxColumn data-field="ProdusNume" caption="Denumire" />
                <DxColumn data-field="Lot" caption="Lot" width="100" />
                <DxColumn data-field="CodBare" caption="Cod de bare" width="200" />
                <DxColumn data-field="Cantitate" caption="Cantitate" data-type="number" format="#,##0.00"
                    width="100" />
                <DxColumn data-field="UnitateSimbol" caption="UM" width="70" />
                <DxColumn data-field="PozitieEticheta" caption="Poziție" width="80" />
                <DxColumn data-field="CountTipariri" caption="Nr. Tipăriri" width="110" />
                <DxColumn caption="" width="90" cell-template="tipareteCellTemplate" :allow-sorting="false"
                    :allow-filtering="false" />

                <template #tipareteCellTemplate="{ data }">
                    <DxButton icon="print" styling-mode="text" hint="Tipărește eticheta"
                        @click="tiparesteEticheta(data.data)" />
                </template>
            </DxDataGrid>

            <div class="scanari-header">Scanări document</div>
            <DxDataGrid :data-source="scanari" key-expr="Id" height="200" :show-borders="true"
                :show-column-lines="false" :show-row-lines="true" :row-alternation-enabled="true"
                :hover-state-enabled="true" :column-auto-width="true" :column-min-width="70"
                :allow-column-resizing="true" column-resizing-mode="nextColumn"
                :allow-column-reordering="true">
                <DxColumn data-field="CodBare" caption="Cod de bare" width="200" />
                <DxColumn data-field="CantitateScanata" caption="Cantitate Scanată" data-type="number"
                    format="#,##0.00" width="130" />
                <DxColumn data-field="Intrare" caption="Intrare" data-type="boolean" width="80" />
                <DxColumn data-field="Iesire" caption="Ieșire" data-type="boolean" width="80" />
                <DxColumn data-field="Procesat" caption="Procesat" data-type="boolean" width="90" />
                <DxColumn data-field="AreRest" caption="Are Rest" data-type="boolean" width="90" />
                <DxColumn data-field="EtichetaRestCantitate" caption="Cantitate Rest" data-type="number"
                    format="#,##0.00" width="120" />
                <DxColumn data-field="EtichetaRestCodBare" caption="Cod Bare Rest" width="150" />
                <DxColumn data-field="EtichetaRestTiparita" caption="Rest Tipărit" data-type="boolean" width="100" />
            </DxDataGrid>
        </div>
    </DxPopup>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue/button';
import { DxTextBox } from 'devextreme-vue/text-box';
import DxDataGrid, { DxColumn, DxSelection } from 'devextreme-vue/data-grid';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import JsBarcode from 'jsbarcode';
import http from '@/settings/apiSettings';
import DOC_Etichete from '@/services/Documente/DOC_Etichete';

interface DocumentProp {
    Id?: string;
    Numar?: string | number | null;
    TipId?: string | null;
    [key: string]: unknown;
}

const props = defineProps<{
    document: DocumentProp;
    linieId?: string | null;
    visible: boolean;
}>();

const emit = defineEmits<{
    (e: 'update:visible', value: boolean): void;
}>();

const loading = ref(false);
const etichete = ref<any[]>([]);
const scanari = ref<any[]>([]);
const scanValue = ref('');
const scanTextBoxRef = ref<any>(null);
const tipInfo = ref<{ AreIntrare?: boolean | null; AreIesire?: boolean | null } | null>(null);
const liniiDocument = ref<any[]>([]);
const currentLinie = ref<any | null>(null);
const selectedLinieId = ref<string | null>(null);

const subtitle = computed(() => {
    const numar = props.document?.Numar != null ? `#${props.document.Numar}` : '';
    return props.linieId ? `Linia curentă — document ${numar}` : `Toate liniile — document ${numar}`;
});

// Linia "activă" pentru grid-ul de etichete: fie linia fixată din props (popup deschis din butonul unei
// linii), fie linia selectată în grid-ul Linii (mod document) — exact ca legacy (LinieCurenta).
const activeLinieId = computed(() => props.linieId ?? selectedLinieId.value);

const primulProdusId = computed(() => {
    if (props.linieId) return currentLinie.value?.ProdusId ?? null;
    if (selectedLinieId.value) {
        const row = liniiDocument.value.find((l: any) => l.Id === selectedLinieId.value);
        if (row?.ProdusId) return row.ProdusId;
    }
    return liniiDocument.value[0]?.ProdusId ?? null;
});

function onLinieSelectionChanged(e: any) {
    const row = e.selectedRowsData?.[0];
    selectedLinieId.value = row?.Id ?? null;
    loadEticheteForActiveLinie();
}

function close() {
    emit('update:visible', false);
}

function onVisibleChange(value: boolean) {
    emit('update:visible', value);
}

function getErrMsg(err: any): string {
    const data = err?.response?.data;
    if (data) {
        if (typeof data === 'string') return data;
        if (data.error?.message) return data.error.message;
        if (data.message) return data.message;
        if (data.title) return data.title;
    }
    return err?.message ?? 'A apărut o eroare.';
}

async function fetchTipInfo() {
    tipInfo.value = null;
    if (!props.document?.TipId) return;
    try {
        const resp = await http.clientDocumenteOdata.get(
            `DOC_Tipuri(${props.document.TipId})?$select=AreIntrare,AreIesire`
        );
        tipInfo.value = resp.data;
    } catch {
        /* ignore */
    }
}

async function fetchCurrentLinie() {
    currentLinie.value = null;
    if (!props.linieId) return;
    try {
        const resp = await http.clientDocumenteOdata.get(`DOC_Linii(${props.linieId})?$select=Id,ProdusId`);
        currentLinie.value = resp.data;
    } catch {
        /* ignore */
    }
}

async function loadData() {
    if (!props.document?.Id) return;
    loading.value = true;
    try {
        if (props.linieId) {
            const resp = await DOC_Etichete.getByLinie(props.linieId);
            etichete.value = resp.data ?? [];
        } else {
            const liniiResp = await http.clientDocumenteOdata.get(
                `DOC_Linii?$filter=DocumentId eq ${props.document.Id}` +
                `&$select=Id,ProdusId,Cantitate,CantitateFa,CantitatePt1Fa` +
                `&$expand=Produs($select=Cod,CodIntern,Nume)`
            );
            liniiDocument.value = liniiResp.data?.value ?? [];
            if (selectedLinieId.value) await loadEticheteForActiveLinie();
        }
    } catch (err: any) {
        notify(getErrMsg(err), 'error', 3000);
    } finally {
        loading.value = false;
    }
}

async function loadEticheteForActiveLinie() {
    const id = activeLinieId.value;
    if (!id) {
        etichete.value = [];
        return;
    }
    try {
        const resp = await DOC_Etichete.getByLinie(id);
        etichete.value = resp.data ?? [];
    } catch (err: any) {
        notify(getErrMsg(err), 'error', 3000);
    }
}

async function loadScanari() {
    if (!props.document?.Id) return;
    try {
        const resp = await DOC_Etichete.getScanari(props.document.Id as string);
        scanari.value = resp.data ?? [];
    } catch (err: any) {
        scanari.value = [];
        notify('Eroare la încărcarea scanărilor: ' + getErrMsg(err), 'error', 4000);
    }
}

async function onGenereaza(overwrite: boolean) {
    const id = activeLinieId.value;
    if (!id) return;
    loading.value = true;
    try {
        const resp = await DOC_Etichete.genereaza(id, overwrite);
        etichete.value = resp.data ?? [];
        notify('Etichetele au fost generate.', 'success', 2000);
    } catch (err: any) {
        if (err?.response?.status === 409) {
            const msg = getErrMsg(err);
            loading.value = false;
            const confirmed = await confirm(
                `${msg}<br/>Doriți să regenerați oricum? Etichetele deja tipărite vor fi anulate.`,
                'Etichete deja tipărite'
            );
            if (confirmed) await onGenereaza(true);
            return;
        }
        notify(getErrMsg(err), 'error', 3000);
    } finally {
        loading.value = false;
    }
}

async function onGenereazaToate() {
    if (!props.document?.Id) return;
    loading.value = true;
    try {
        const resp = await DOC_Etichete.genereazaToate(props.document.Id);
        const r = resp.data ?? {};
        notify(
            `Procesate ${r.LiniiProcesate ?? 0}, Ignorate ${r.LiniiIgnorate ?? 0}, Generate ${r.EticheteGenerate ?? 0} etichete.`,
            'success',
            4000
        );
        await loadData();
    } catch (err: any) {
        notify(getErrMsg(err), 'error', 3000);
    } finally {
        loading.value = false;
    }
}

function focusScanInput() {
    nextTick(() => {
        (scanTextBoxRef.value as any)?.instance?.focus();
    });
}

async function onScan() {
    const cod = scanValue.value?.trim();
    if (!cod) return;
    try {
        await DOC_Etichete.scaneaza({
            DocumentId: props.document.Id as string,
            ProdusId: primulProdusId.value,
            CantitateScanata: 1,
            CodBare: cod,
            Intrare: !!tipInfo.value?.AreIntrare,
            Iesire: !!tipInfo.value?.AreIesire,
        });
        notify('Codul a fost scanat cu succes.', 'success', 1500);
        await Promise.all([loadData(), loadScanari()]);
    } catch (err: any) {
        notify(getErrMsg(err), 'error', 3000);
    } finally {
        scanValue.value = '';
        focusScanInput();
    }
}

function openPrintWindow(html: string) {
    const win = window.open('', '_blank');
    if (!win) {
        notify('Permiteți pop-up-uri pentru a tipări etichetele.', 'warning', 4000);
        return;
    }
    win.document.open();
    win.document.write(html);
    win.document.close();
}

function marcheazaTiparitFireAndForget(id: string) {
    DOC_Etichete.marcheazaTiparit(id).catch((err) => console.error('Eroare marcare etichetă tipărită:', err));
}

function buildBarcodeDataUrl(codBare: string): string {
    const canvas = window.document.createElement('canvas');
    JsBarcode(canvas, codBare || ' ', { format: 'CODE128', displayValue: true });
    return canvas.toDataURL('image/png');
}

function buildEticheteHtml(items: any[]): string {
    const esc = (s: any) => (s ?? '').toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const labelsHtml = items
        .map((et, idx) => {
            const imgData = buildBarcodeDataUrl(et.CodBare);
            const pageBreak = idx < items.length - 1 ? 'page-break-after: always;' : '';
            return `<div class="label-page" style="${pageBreak}">
    <div class="label-produs">${esc(et.ProdusCodIntern ?? '-')}</div>
    <div class="label-lot">Lot: ${esc(et.Lot ?? '-')}</div>
    <div class="label-cant">${esc(et.Cantitate ?? '')} ${esc(et.CodUM ?? '')}</div>
    <img class="label-barcode" src="${imgData}" alt="${esc(et.CodBare)}" />
</div>`;
        })
        .join('');

    return `<!DOCTYPE html><html lang="ro"><head><meta charset="utf-8"/><title>Etichete</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:Arial,sans-serif;font-size:9pt;color:#1e293b;background:#fff}
.label-page{width:60mm;height:40mm;padding:2mm;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1mm}
.label-produs{font-weight:700;font-size:9pt;text-align:center}
.label-lot,.label-cant{font-size:8pt;color:#475569}
.label-barcode{max-width:56mm;max-height:18mm}
.print-btn{margin:6px;text-align:center}
.print-btn button{padding:8px 22px;background:#ff2c21;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:10pt;font-family:Arial,sans-serif}
@media print{.print-btn{display:none}}
@page{size:60mm 40mm;margin:2mm}
</style></head><body>
<div class="print-btn"><button onclick="window.print()">Tipărește</button></div>
${labelsHtml}
</body></html>`;
}

function tiparesteEticheta(eticheta: any) {
    if (!eticheta?.CodBare) {
        notify('Eticheta nu are un cod de bare valid.', 'warning', 3000);
        return;
    }
    const html = buildEticheteHtml([eticheta]);
    openPrintWindow(html);
    marcheazaTiparitFireAndForget(eticheta.Id);
}

function onTipareteToate() {
    const items = etichete.value.filter((et) => !!et.CodBare);
    if (items.length === 0) {
        notify('Nu există etichete de tipărit.', 'warning', 3000);
        return;
    }
    const html = buildEticheteHtml(items);
    openPrintWindow(html);
    items.forEach((et) => marcheazaTiparitFireAndForget(et.Id));
}

function refresh() {
    selectedLinieId.value = null;
    fetchTipInfo();
    fetchCurrentLinie();
    loadData();
    loadScanari();
}

watch(() => props.visible, (v) => {
    if (v) refresh();
});

watch(() => props.linieId, () => {
    if (props.visible) refresh();
});

onMounted(() => {
    if (props.visible) refresh();
});
</script>

<style scoped>
.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
    width: 100%;
}

.popup-header-main {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon {
    font-size: 20px;
}

.popup-header-texts {
    display: flex;
    flex-direction: column;
}

.popup-header-title {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle {
    font-size: 12px;
    opacity: 0.85;
}

.popup-close-btn {
    color: #fff !important;
}

.etichete-popup-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 4px 2px;
}

.etichete-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.etichete-scan-row {
    max-width: 420px;
}

.scanari-header {
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 4px;
}
</style>
